/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ linked: NonNullable<unknown> }} Pm_AppliedInputs */

const cs_pm_applied = /** @type {(inputs: Pm_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uloženo ${i?.linked} ID inzerátů`)
};

const en_pm_applied = /** @type {(inputs: Pm_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saved ${i?.linked} listing IDs`)
};

/**
* | output |
* | --- |
* | "Saved {linked} listing IDs" |
*
* @param {Pm_AppliedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_applied = /** @type {((inputs: Pm_AppliedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_AppliedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_applied(inputs)
	return cs_pm_applied(inputs)
});